<template>
    <div class="sbs-video-player-play-toggle">
        <SbsTooltip v-bind="tooltipData">
            <div ref="playToggle"></div>
        </SbsTooltip>
        <div ref="playToggleIcon">
            <SbsVideoPlayerPlayToggleIcon class="sbs-video-player-play-toggle__icon" />
        </div>
    </div>
</template>

<script>
import videojs from 'video.js';
import { toRaw } from 'vue';
import SbsTooltip from '../../tooltip/SbsTooltip.vue';
import SbsVideoPlayerPlayToggleIcon from './SbsVideoPlayerPlayToggleIcon.vue';

export default {
    name: 'SbsVideoPlayerPlayToggle',
    components: {
        SbsTooltip,
        SbsVideoPlayerPlayToggleIcon,
    },
    inject: {
        videoPlayerComponent: { default: null },
    },
    data() {
        return {
            videoEnded: false,
            playToggleComponent: null,
        };
    },
    computed: {
        player() {
            return toRaw(this.videoPlayerComponent.player);
        },
        tooltipData() {
            return {
                offset: 0,
                parentSelector: this.videoPlayerComponent.videoContainerSelector,
                position: 'top-start',
                content: 'Повторить',
                disabled: !this.videoEnded,
            };
        },
    },
    methods: {
        videoEndedStatus() {
            this.videoEnded = this.player.ended();
        },
        addListeners() {
            this.playToggleComponent.on('pointerover', this.videoEndedStatus);
            this.playToggleComponent.on('ended', this.videoEndedStatus);
        },
        removeListeners() {
            this.playToggleComponent.off('pointerover', this.videoEndedStatus);
            this.playToggleComponent.off('ended', this.videoEndedStatus);
        },
    },
    mounted() {
        const PlayToggle = videojs.getComponent('playToggle');

        this.playToggleComponent = new PlayToggle(this.player);

        const Component = videojs.getComponent('Component');
        const playToggle = this.player.controlBar.addChild('ClickableComponent', {
            el: this.$refs.playToggle,
        });
        const playToggleIcon = new Component(this.player, {
            el: this.$refs.playToggleIcon,
        });

        this.addListeners();

        playToggle.addChild(this.playToggleComponent);
        this.playToggleComponent.addChild(playToggleIcon);
    },
    beforeUnmount() {
        this.removeListeners();
    },
};
</script>

<style lang="scss">
.sbs-video-player-play-toggle {
    &__icon {
        width: 20px;
        height: 20px;
    }
}
</style>
